import { render, staticRenderFns } from "./CompareModal.vue?vue&type=template&id=24c25bfc&"
import script from "./CompareModal.vue?vue&type=script&lang=ts&"
export * from "./CompareModal.vue?vue&type=script&lang=ts&"
import style0 from "./CompareModal.vue?vue&type=style&index=0&id=24c25bfc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports